export function getBillType(value: string){
    switch (value) {
        case 'billet':
            return 'Boleto';
        case 'account':
            return 'Conta';
        default:
            return '';
    }
}